import { Button } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { BACK_ROUTES_PATH } from './route-path';
import { useNavigationHistory } from '@/common/navigation-history';
import { useEffect } from 'react';
import { returnLinks } from '@/common/navigation-history/data';
import { useTransactionContext } from '@/context/TransactionContext';
import { exclude } from './data';
import { AntButton } from '@/common/ant-components/AntButton';

export const Back = () => {
  let navigate = useNavigate();
  const location = useLocation();
  const pathname = location?.pathname;

  const state = location?.state || null;

  const isExcluded = exclude?.some((path) =>
    location?.pathname?.startsWith(path),
  );

  const isRedirectPath = BACK_ROUTES_PATH?.find(
    (item) => item?.route === pathname || pathname?.startsWith(item.route),
  )?.route_to_redirect;

  const history = useNavigationHistory();

  const { ledgerDetails, stockDetails, setLedgerDetails } =
    useTransactionContext();

  const stateData = ledgerDetails
    ? ledgerDetails
    : stockDetails?.code
      ? stockDetails
      : state;

  const target = isExcluded
    ? null
    : Array.isArray(history)
      ? [...history]
          .reverse()
          .find(
            (path, index) =>
              index === 1 &&
              returnLinks?.some((prefix) => path.startsWith(prefix)),
          )
      : null;

  const last = history?.[history?.length - 1] || '';
  const secondLast = history?.[history?.length - 2] || '';

  const isHistoryContainsSundry =
    last.includes('/sundry') ||
    secondLast.includes('/sundry') ||
    last.includes('/debtors') ||
    secondLast.includes('/debtors');

  const isFromDashboard = state?.from === 'dashboard';

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.code === 'Escape') {
        e.preventDefault();
        if (target) {
          navigate(target, {
            state: {
              ...stateData,
              from: state?.from === 'sundry' ? 'sundry' : null,
            },
          });
          return;
        } else if (isFromDashboard) {
          navigate('/dashboard/');
        } else if (isRedirectPath) {
          navigate(isRedirectPath, {
            state: {
              ...stateData,
            },
          });
          return;
        } else {
          navigate(-1);
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [navigate, target, stateData, isRedirectPath, state?.from]);

  useEffect(() => {
    if (location?.pathname?.includes('/stock/ledger/report/')) {
      setLedgerDetails(null);
    }
  }, [location?.pathname?.includes('/stock/ledger/report/')]);

  return (
    <AntButton
      style={{
        marginLeft: '15px',
        marginRight: '4px',
        display: 'flex',
        alignItems: 'center',
        marginBottom: '5px',
      }}
      onClick={() => {
        target
          ? navigate(target, {
              state: {
                ...stateData,
                from: state?.from
                  ? state.from
                  : isHistoryContainsSundry
                    ? 'sundry'
                    : null,
              },
            })
          : isFromDashboard
            ? navigate('/dashboard/')
            : isRedirectPath
              ? navigate(isRedirectPath, {
                  state: {
                    ...stateData,
                  },
                })
              : navigate(-1);
      }}
    >
      Back
    </AntButton>
  );
};
